module.exports = __webpack_public_path__ + "static/media/opexD.5c90907c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/opexD.svg
// module id = 391
// module chunks = 7